// Single source of truth for internal admin roles that may access the admin panel.
// Keep in sync with INTERNAL_ROLES in backend/server.py.
export const ADMIN_ROLES = [
  "admin",
  "super_admin",
  "operations_manager",
  "brand_onboarding_executive",
  "catalogue_manager",
  "wellness_curator",
  "commercial_manager",
  "compliance_manager",
  "content_manager",
  "approver_category_head",
  "viewer_management",
];
